import { createAuthAxios } from './auth';

const syncService = {
  /**
   * Lists messages that exist in QuePasa but not in Chatwoot
   * @param {number} accountId - Account ID
   * @param {number} inboxId - Inbox ID
   * @returns {Promise<{missing: string[], count: number}>} Missing message IDs
   * @example
   * const missing = await quepasa.service.sync.missingMessages(1, 803);
   * console.log(`Missing ${missing.count} messages`);
   */
  async missingMessages(accountId, inboxId) {
    const http = createAuthAxios();
    const response = await http.get(
      `/api/v1/accounts/${accountId}/quepasa/${inboxId}/sync/missing_messages`
    );
    return response.data;
  },

  async syncMessages(accountId, inboxId, messageIds) {
    const http = createAuthAxios();
    const response = await http.post(
      `/api/v1/accounts/${accountId}/quepasa/${inboxId}/sync/sync_messages`,
      { message_ids: messageIds }
    );
    return response.data;
  },

  async syncAll(accountId, inboxId) {
    const http = createAuthAxios();
    const response = await http.post(
      `/api/v1/accounts/${accountId}/quepasa/${inboxId}/sync/sync_all`
    );
    return response.data;
  },

  async importPreview(accountId, inboxId, params = {}) {
    const http = createAuthAxios();
    const response = await http.get(
      `/api/v1/accounts/${accountId}/quepasa/${inboxId}/sync/import_preview`,
      { params }
    );
    return response.data;
  },

  async importDirect(accountId, inboxId, body = {}) {
    const http = createAuthAxios();
    const response = await http.post(
      `/api/v1/accounts/${accountId}/quepasa/${inboxId}/sync/import_direct`,
      body
    );
    return response.data;
  },

  async importStatus(accountId, inboxId, executionId = null) {
    const http = createAuthAxios();
    const response = await http.get(
      `/api/v1/accounts/${accountId}/quepasa/${inboxId}/sync/import_status`,
      { params: executionId ? { execution_id: executionId } : {} }
    );
    return response.data;
  }
};

// Add help properties to each method
syncService.missingMessages.help = 'missingMessages(accountId, inboxId) - Lists messages in QuePasa but not in Chatwoot. Returns: {missing: string[], count: number}';
syncService.syncMessages.help = 'syncMessages(accountId, inboxId, messageIds) - Syncs specific messages from QuePasa to Chatwoot. Pass array of message IDs.';
syncService.syncAll.help = 'syncAll(accountId, inboxId) - Syncs all missing messages from QuePasa to Chatwoot. Processes entire backlog.';

export default syncService;
